import React from "react";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Dropdown} from "primereact/dropdown";
import {Fieldset} from "primereact/fieldset";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";

const AvailableValuesFid = ({headerAvailableValuesFid}) => {
    return (
        <React.Fragment>
            <Paper elevation={5}
                   style={{paddingTop: '2%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TitlePage title="Valores Disponibles como Prestamista"/>
                    </Grid>
                    <Grid item xs={12}>
                        <Fieldset legend="Filtros" toggleable={true} collapsed={true}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item>
                                    <Dropdown
                                        placeholder="Emisora"
                                        filter={true}
                                        filterBy="label"
                                        showClear={true}
                                    />
                                </Grid>
                                <Grid item>
                                    <Button label="Limpiar"/>
                                </Grid>
                            </Grid>
                        </Fieldset>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            header={headerAvailableValuesFid}
                            responsive={true}>
                            <Column field="emisora" header="Emisora"/>
                            <Column field="institución" header="Institutción"/>
                            <Column field="cantidad" header="Títulos"/>
                            <Column field="precio" header="Precio"/>
                            <Column field="importe" header="Importe"/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};
export default AvailableValuesFid;